import { render, staticRenderFns } from "./insureBeginHint.vue?vue&type=template&id=48faf692&scoped=true&"
import script from "./insureBeginHint.vue?vue&type=script&lang=js&"
export * from "./insureBeginHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48faf692",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48faf692')) {
      api.createRecord('48faf692', component.options)
    } else {
      api.reload('48faf692', component.options)
    }
    module.hot.accept("./insureBeginHint.vue?vue&type=template&id=48faf692&scoped=true&", function () {
      api.rerender('48faf692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/insureBeginHint.vue"
export default component.exports